<template>
    <section class="col-12" :class="{'mt-5': !readonly}">
        <label v-if="!readonly"><strong>Documents Archived</strong></label>
        <div class="table table-responsive">
            <table v-if="documents.length > 0" class="table table-responsive table-striped table-bordered d-table">
                <thead>
                <tr>
                    <td style="width:30%">Description</td>
                    <td style="width:60%">File</td>
                    <td>Delete</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, itemIndex) in documents">
                    <td>
                       {{item.description}}

                    </td>
                    <td>
                       <a target="_blank" :href="'/'+item.file">Open File</a>
                    </td>
                    <td><a @click="deleteLine(item.id, itemIndex)" title="Delete" class="btn btn-danger text-white"><span
                        class="fa fa-trash"></span></a></td>
                </tr>
                </tbody>
                <tfoot>
                </tfoot>
            </table>
            <table v-if="!readonly" class="table table-responsive table-striped table-bordered d-table">
                <thead>
                <tr>
                    <td style="width:30%">Description</td>
                    <td style="width:60%">File</td>
                    <td>Delete</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, itemIndex) in items">
                    <td>
                        <input :name="'documents['+itemIndex+'][description]'" type="text"
                               class="form-control"/>

                    </td>
                    <td>
                        <input :name="'documents['+itemIndex+'][file]'" type="file"
                               class="form-control"/>
                    </td>
                    <td><a @click="deleteLine(item.id, itemIndex)" title="Delete" class="btn btn-danger text-white"><span
                        class="fa fa-trash"></span></a></td>
                </tr>
                </tbody>
                <tfoot>
                <tr >
                    <th colspan="9">
                        <button @click="addLine()" type="button"
                                class="btn btn-success"
                                data-toggle="tooltip"
                                data-original-title="Add more lines">
                            <i class="glyphicon glyphicon-plus-sign"></i>
                            Add
                        </button>

                    </th>

                </tr>
                </tfoot>
            </table>
        </div>
    </section>
</template>

<script>
import {monthNames, URL_BASE, years} from '../../../utils/helper';
import _ from "lodash";
import SiteDocument from "../../../models/SiteDocument";

export default {
    name: "SiteDocumentsComponent",
    props: {
        documents: {
            type: Array
        },
        readonly: {
            type: Boolean,
            default: false,
        }
    },
    data: function () {
        return {
            items: [],
            types: []
        }
    },
    mounted() {

    },
    methods: {
        addLine() {
            let item = new SiteDocument()
            this.items.push(item);
        },
        deleteLine(id, itemIndex) {
            if (id) {
                this.$loading(true);
                let app = this;
                axios.delete(URL_BASE + '/sites/document/' + id)
                    .then((response) => {
                        this.$loading(false);
                        app.items.splice(itemIndex, 1);
                    })
                    .catch(error => {
                        this.$loading(false);
                        let message = '';
                        if (_.has(error, 'response.data.friendly_message')) {

                            message = error.response.status + ' - ' + error.response.data.friendly_message;

                        } else if (_.has(error, 'response.status')) {

                            message = 'Request failed with status code ' + error.response.status;

                        } else {
                            message = 'Application failed with error: ' + error.message;
                            console.log(error);
                        }

                        showMessage('w', message);


                    })
            } else {
                this.items.splice(itemIndex, 1);
            }

        },
    }
}
</script>

<style scoped>

</style>
